import React, { useState } from 'react'
import PropTypes from 'prop-types'

const t = (key, opts) => !window.I18n ? '' : window.I18n.t(key, opts)

// Past Rounds Summary always shows/saves the 18-hole index (usga_index),
// independent of the 9/18 holes toggle used elsewhere on the page.
const RoundCard = ({ round, onUpdate }) => {
  const [value, setValue] = useState(round.usga_index || '')

  const handleChange = (e) => {
    setValue(e.target.value)
    if (onUpdate) onUpdate(round.player_id, e.target.value)
  }

  return (
    <div className='round-card'>
      <div className='round-card__name'>{round.name}</div>
      <div className='round-card__date'>{round.date}</div>
      {onUpdate ? (
        <input
          type='text'
          className='round-card__input'
          value={value}
          onChange={handleChange}
        />
      ) : (
        <div className='round-card__value'>{round.usga_index || '—'}</div>
      )}
    </div>
  )
}

RoundCard.propTypes = {
  round: PropTypes.object.isRequired,
  onUpdate: PropTypes.func,
}

const PastRoundsSummary = ({ rounds, onUpdate }) => {
  const [collapsed, setCollapsed] = useState(false)

  if (!rounds || rounds.length === 0) return null

  const toggle = () => setCollapsed(v => !v)
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggle()
    }
  }

  return (
    <div className='past-rounds-summary'>
      <div
        className='past-rounds-summary__header'
        role='button'
        tabIndex={0}
        aria-expanded={!collapsed}
        aria-controls='past-rounds-summary-cards'
        onClick={toggle}
        onKeyDown={handleKeyDown}
      >
        <span className='past-rounds-summary__title'>{t('member_handicap_history.past_rounds_summary.title')}</span>
        <span className='past-rounds-summary__count'>{t('member_handicap_history.past_rounds_summary.rounds_count', { count: rounds.length })}</span>
        <i className={`past-rounds-summary__toggle fa fa-chevron-${collapsed ? 'down' : 'up'}`} aria-hidden='true' />
      </div>
      {!collapsed && (
        <div className='past-rounds-summary__cards' id='past-rounds-summary-cards'>
          {rounds.map((round) => (
            <RoundCard
              key={round.player_id}
              round={round}
              onUpdate={onUpdate}
            />
          ))}
        </div>
      )}
    </div>
  )
}

PastRoundsSummary.defaultProps = {
  onUpdate: null,
}

PastRoundsSummary.propTypes = {
  rounds: PropTypes.arrayOf(PropTypes.shape({
    player_id: PropTypes.string,
    name: PropTypes.string,
    date: PropTypes.string,
    usga_index: PropTypes.string,
    nine_hole_index: PropTypes.string,
  })),
  onUpdate: PropTypes.func,
}

export default PastRoundsSummary
